import { render } from "./prescheduled-table.vue?vue&type=template&id=bd874aac&scoped=true"
import script from "./prescheduled-table.vue?vue&type=script&lang=js"
export * from "./prescheduled-table.vue?vue&type=script&lang=js"

import "./prescheduled-table.vue?vue&type=style&index=0&id=bd874aac&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd874aac"]])

export default __exports__